import { STRING_CONSTANTS } from "constants/common";
import CryptoJS from "crypto-js";

const encryptionKey = "shoppinggate-encryption-2025";

export const encryptLocalData = (data, key) => {
  if (data && data !== "" && data !== "null") {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      key
    ).toString();
    return encrypted;
  }
  return data;
};

const decryptLocalData = (encryptedData, key) => {
  if (encryptedData && encryptedData !== "" && encryptedData !== "null") {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, key);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    } catch (error) {
      console.error('Error decrypting data:', error);
      return encryptedData;
    }
  }
  return encryptedData;
};

export const getStorageItem = (key) => {
  const encryptedData = localStorage.getItem(key);
  return decryptLocalData(encryptedData, encryptionKey);
};

export const saveItemToStorage = (key, value, callback = null) => {
  const encryptedData = encryptLocalData(value, encryptionKey);
  localStorage.setItem(key, encryptedData);
  if (callback) callback();
};

export const getItemFromLocal = (key) => {
  return localStorage.getItem(key);
};

export const saveItemToLocal = (key, value) => {
  localStorage.setItem(key, value);
};

export const removeItemFromStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = (excludeKeys = []) => {
  if (
    Array.isArray(excludeKeys) &&
    !excludeKeys?.includes(STRING_CONSTANTS.STORED_KEYS.LOGIN_CREDENTIALS)
  ) {
    excludeKeys.push(STRING_CONSTANTS.STORED_KEYS.LOGIN_CREDENTIALS);
  }

  const preservedData = {};

  if (excludeKeys.length > 0) {
    excludeKeys?.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        preservedData[key] = value;
      }
    });
  }

  localStorage.clear();

  Object.keys(preservedData).forEach((key) => {
    localStorage.setItem(key, preservedData[key]);
  });
};


